import Text from '~/components/Text/Text'
import {
  Legend,
  LegendGrid,
  LegendStockBox,
  LegendPillTip
} from './SaFLegend.styles'
import StockArrow from '../StockArrow/StockArrow'
import { useTranslation } from 'react-i18n-lite'

export default function SaFLegend() {
  const { t } = useTranslation()

  return (
    <Legend>
      <Text variant='content-emphasis-03'>{t('saf.legend')}:</Text>

      <LegendGrid>
        <Text variant='content-03'>{t('saf.in')}</Text>
        <LegendPillTip $direction='up' />
        <LegendPillTip $direction='down' />
        <Text variant='content-03'>{t('saf.out')}</Text>

        <Text variant='content-03'>{t('saf.initial-stock')}</Text>
        <LegendStockBox>
          <StockArrow
            boxHeight={1}
            inValue={1}
            outValue={1}
            remainingStock={0}
          />
        </LegendStockBox>
        <LegendStockBox />
        <Text variant='content-03'>{t('saf.final-stock')}</Text>
      </LegendGrid>
    </Legend>
  )
}
